import React, { useState, useEffect, useRef } from 'react';
import './Identidad.css';

const Identidad = () => {
  const [flippedCards, setFlippedCards] = useState({});
  const haloRef = useRef(null);

  const toggleCard = (cardId) => {
    setFlippedCards(prev => ({
      ...prev,
      [cardId]: !prev[cardId]
    }));
  };

  const setCardSide = (cardId, isFlipped) => {
    setFlippedCards(prev => ({
      ...prev,
      [cardId]: isFlipped
    }));
  };

  useEffect(() => {
    // Efecto halo que sigue al mouse
    const handleMouseMove = (e) => {
      if (haloRef.current) {
        haloRef.current.style.left = `${e.clientX}px`;
        haloRef.current.style.top = `${e.clientY}px`;
      }
    };

    document.addEventListener('mousemove', handleMouseMove);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  const valuesData = [
    {
      id: 'integridad',
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"/>
        </svg>
      ),
      title: 'Integridad',
      subtitle: 'Base de todas nuestras acciones',
      description: 'La integridad es el fundamento de nuestra empresa. Actuamos con honestidad, transparencia y ética en cada decisión y proyecto que emprendemos.',
      details: [
        'Transparencia en todos nuestros procesos',
        'Honestidad en la comunicación con clientes',
        'Ética profesional en cada proyecto',
        'Responsabilidad en nuestros compromisos',
        'Coherencia entre valores y acciones'
      ]
    },
    {
      id: 'excelencia',
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      ),
      title: 'Excelencia',
      subtitle: 'Compromiso con la calidad superior',
      description: 'Buscamos la excelencia en cada detalle, desde la planificación hasta la ejecución, asegurando resultados que superen las expectativas de nuestros clientes.',
      details: [
        'Estándares de calidad internacionales',
        'Mejora continua en nuestros procesos',
        'Capacitación constante del equipo',
        'Innovación en metodologías de trabajo',
        'Atención meticulosa a los detalles'
      ]
    },
    {
      id: 'innovacion',
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M9 21c0 .5.4 1 1 1h4c.6 0 1-.5 1-1v-1H9v1zm3-19C8.1 2 5 5.1 5 9c0 2.4 1.2 4.5 3 5.7V17c0 .5.4 1 1 1h6c.6 0 1-.5 1-1v-2.3c1.8-1.3 3-3.4 3-5.7 0-3.9-3.1-7-7-7z"/>
        </svg>
      ),
      title: 'Innovación',
      subtitle: 'Tecnología al servicio del progreso',
      description: 'Adoptamos las últimas tecnologías y metodologías para ofrecer soluciones innovadoras que impulsen el desarrollo sostenible de la industria.',
      details: [
        'Implementación de tecnologías avanzadas',
        'Desarrollo de soluciones personalizadas',
        'Investigación constante del mercado',
        'Adaptación a nuevas tendencias',
        'Optimización de recursos y procesos'
      ]
    },
    {
      id: 'sostenibilidad',
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M17 8C8 10 5.9 16.17 3.82 21.34l1.06.66C6.8 17.85 9.91 12.65 19 11l-2-3zm-5 3c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"/>
        </svg>
      ),
      title: 'Sostenibilidad',
      subtitle: 'Compromiso con el medio ambiente',
      description: 'Desarrollamos proyectos que respetan el medio ambiente, implementando prácticas sostenibles que contribuyen al bienestar de las comunidades.',
      details: [
        'Prácticas ambientalmente responsables',
        'Uso eficiente de recursos naturales',
        'Minimización del impacto ambiental',
        'Contribución al desarrollo local',
        'Certificaciones ambientales'
      ]
    },
    {
      id: 'seguridad',
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M18,8A6,6 0 0,0 12,2A6,6 0 0,0 6,8H4A2,2 0 0,0 2,10V20A2,2 0 0,0 4,22H20A2,2 0 0,0 22,20V10A2,2 0 0,0 20,8H18M12,4A4,4 0 0,1 16,8H8A4,4 0 0,1 12,4Z"/>
        </svg>
      ),
      title: 'Seguridad',
      subtitle: 'Prioridad absoluta en cada proyecto',
      description: 'La seguridad de nuestro personal y clientes es nuestra máxima prioridad. Implementamos los más altos estándares de seguridad industrial.',
      details: [
        'Protocolos de seguridad estrictos',
        'Capacitación continua en seguridad',
        'Equipos de protección de alta calidad',
        'Auditorías regulares de seguridad',
        'Cultura de prevención de riesgos'
      ]
    },
    {
      id: 'compromiso',
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M17,8.5L13.5,12L10.5,9L6.5,13L8,14.5L10.5,12L13.5,14.5L18.5,10L17,8.5Z"/>
        </svg>
      ),
      title: 'Compromiso',
      subtitle: 'Dedicación total con nuestros clientes',
      description: 'Nos comprometemos completamente con el éxito de cada proyecto, asegurando la entrega puntual y la satisfacción total de nuestros clientes.',
      details: [
        'Cumplimiento de plazos establecidos',
        'Comunicación constante con clientes',
        'Adaptabilidad a requerimientos',
        'Servicio post-proyecto',
        'Garantía de calidad en resultados'
      ]
    }
  ];

  return (
    <div className="identidad-container">
      <div className="halo" ref={haloRef}></div>
      
      {/* Hero Section */}
      <section className="identidad-hero">
        <div className="container">
          <h1 className="hero-title">
            Nuestra <span className="highlight">Identidad</span>
          </h1>
          <div className="animated-underline"></div>
          <p className="hero-subtitle">
            En Rêver construimos más que infraestructura: creamos confianza e innovación. Somos una empresa mexicana fundada en 2022, con visión global, especializada en construcción para los Sectores de <span className="highlight">Minería, Energía y Oil & Gas.</span> 
            Conformados por expertos multidisciplinarios, combinamos experiencia, eficiencia e innovación para desarrollar proyectos de alto impacto. 
            Nuestra misión es transformar el entorno con soluciones sostenibles y de calidad, consolidándonos como referentes en la industria.
          </p>
        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider"></div>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">
              Nuestros <span className="highlight">Valores</span>
            </h2>
            <div className="animated-underline"></div>
            <p className="section-subtitle">
              Los principios que guían cada una de nuestras acciones y decisiones en el desarrollo 
              de proyectos de alta complejidad y precisión técnica.
            </p>
          </div>

          <div className="values-grid">
            {valuesData.map((value) => (
              <div 
                key={value.id} 
                className={`flip-card ${flippedCards[value.id] ? 'flipped' : ''}`}
              >
                <div className="flip-card-inner">
                  {/* Front Side */}
                  <div className="flip-card-front">
                    <button 
                      className="flip-button"
                      onClick={() => toggleCard(value.id)}
                      aria-label="Voltear tarjeta"
                      title="Voltear tarjeta"
                    >
                      <svg viewBox="0 0 24 24">
                        <path d="M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8Z"/>
                      </svg>
                    </button>
                    
                    <div className="card-icon">
                      {value.icon}
                    </div>
                    <h3 className="card-title">{value.title}</h3>
                    <p className="card-subtitle">{value.subtitle}</p>
                    <p className="card-description">{value.description}</p>
                    
                    
                  </div>

                  {/* Back Side */}
                  <div className="flip-card-back">
                    <button 
                      className="flip-button"
                      onClick={() => toggleCard(value.id)}
                      aria-label="Voltear tarjeta"
                      title="Volver"
                    >
                      <svg viewBox="0 0 24 24">
                        <path d="M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8Z"/>
                      </svg>
                    </button>
                    
                    <div className="card-icon">
                      {value.icon}
                    </div>
                    <h3 className="card-title">{value.title}</h3>
                    <ul className="card-list">
                      {value.details.map((detail, index) => (
                        <li key={index}>{detail}</li>
                      ))}
                    </ul>
                    

                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider"></div>

      {/* Mission & Vision Section */}
      <section className="mission-vision-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">
              Misión y <span className="highlight">Visión</span>
            </h2>
            <div className="animated-underline"></div>
            <p className="section-subtitle">
              El propósito que nos impulsa y el futuro que aspiramos construir a través 
              de la <span className="highlight">excelencia operativa</span> y la innovación constante.
            </p>
          </div>

          <div className="mission-vision-grid">
            <div className="mission-vision-card">
              <div className="mission-vision-icon">
                <svg viewBox="0 0 24 24">
                  <path d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M11,4H6V20H11L18,13V10H11V4Z"/>
                </svg>
              </div>
              <h3>Misión</h3>
              <p>
                Somos una empresa mexicana especializada en construcción para los sectores de la Minería, Energía y Oil & Gas, comprometida con brindar soluciones 
                integrales de la más alta calidad. Nuestro equipo multidisciplinario aporta 
                experiencia, eficiencia e innovación para desarrollar proyectos de alto impacto 
                que transformen el entorno con soluciones sostenibles.
              </p>
            </div>

            <div className="mission-vision-card">
              <div className="mission-vision-icon">
                <svg viewBox="0 0 24 24">
                  <path d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z"/>
                </svg>
              </div>
              <h3>Visión</h3>
              <p>
                Ser reconocidos como la empresa líder a nivel 
                global, destacando por nuestra excelencia operativa, innovación tecnológica 
                y compromiso con la sostenibilidad. Aspiramos a ser el socio estratégico 
                preferido de nuestros clientes, contribuyendo al desarrollo de infraestructuras 
                que impulsen el progreso de las industrias más importantes del mundo.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider"></div>
    </div>
  );
};

export default Identidad;